/**
 * @Author: alexandre
 * @Date:   2018-03-12T14:18:12-04:00
 * @Email:  alexandre@atomicmotion.com
 * @Filename: popup.jsx
 * @Last modified by:   alexandre
 * @Last modified time: 2018-06-04T16:55:07-04:00
 * @Copyright: Atomic Motion
 */

import React, {
  Component,
} from 'react';
import axios from 'axios';

class Popup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display: false,
      name: this.props.name,
      attention: "",
      street1: "",
      street2: "",
      city: "",
      province: "",
      postal: "",
      notes: "",
      popMessage: "",
    };
  }

  componentWillMount = () => {

    this.setState({
      display: this.props.display,
    })
  }

  goBack = (e) => {

    e.preventDefault();
    this.props.openPopup(e)
  }

  validateForm = (e) => {

    e.preventDefault();

    var params = new URLSearchParams();
    params.append(this.props.lang === "en" ? 'name' : 'nom', this.state.name);
    params.append('attention', this.state.attention);
    params.append(this.props.lang === "en" ? 'street1' : 'rue1', this.state.street1);
    params.append(this.props.lang === "en" ? 'street2' : 'rue2', this.state.street2);
    params.append(this.props.lang === "en" ? 'city' : 'ville', this.state.city);
    params.append('province', this.state.province);
    params.append(this.props.lang === "en" ? 'postal' : 'code_postal', this.state.postal);
    params.append(this.props.lang === "en" ? 'notes' : 'remarque', this.state.notes);

    params.append('title', this.props.lang === "en" ? 'CDAnet - Contribute mailing address information' : 'CDAnet - Fournir l’adresse postale de l’assureur')

    axios.post('http://php.atomicmotion.com/sendmail_cda.php', params).then(resUser => {
      this.setState({ popMessage: this.props.lang === "en" ? "Thank-you, the mailing address has been received." : "Merci, l’adresse postale a été reçue" })
      

    }).catch(error => {
      this.setState({ popMessage: "Sorry, something went wrong" })
    });
  }

  attentionChange(event) {

    const newVal = event.target.value
    this.setState({
      attention: newVal
    })
  }
  street1Change(event) {

    const newVal = event.target.value
    this.setState({
      street1: newVal
    })
  }
  street2Change(event) {

    const newVal = event.target.value
    this.setState({
      street2: newVal
    })
  }
  cityChange(event) {

    const newVal = event.target.value
    this.setState({
      city: newVal
    })
  }
  provinceChange(event) {

    const newVal = event.target.value
    this.setState({
      province: newVal
    })
  }
  postalChange(event) {

    const newVal = event.target.value
    this.setState({
      postal: newVal
    })
  }
  notesChange(event) {

    const newVal = event.target.value
    this.setState({
      notes: newVal
    })
  }

  render() {

    return (
      <div ref="popup" className={this.state.display? "popup": "hidden popup"}>
        <div className="pop-container">
        <h1>{this.props.lang === "en" ? <span>Contribute carrier mailing address information</span> : <span>Fournir l’adresse postale de l’assureur</span>}</h1>
          <div className="header-container">
            <h2>{this.props.name}</h2>
            <a href="goback" onClick={this.goBack}>{this.props.lang === "en" ? <span>Close</span> : <span>Fermer</span>}</a>
          </div>
        <form >
          {this.state.popMessage === "" && <div> 
              <p>
                <label for="attention">Attention</label>
                <input type="text" name="attention" value={this.state.attention} onChange={this.attentionChange.bind(this)}/>
              </p>

              <p>
                <label for="street1">{this.props.lang === "en" ? <span>Street 1</span> : <span>Rue 1</span> }</label>
                <input type="text" name="street1" value={this.state.street1} onChange={this.street1Change.bind(this)}/>
              </p>

              <p>
                <label for="street2">{this.props.lang === "en" ? <span>Street 2</span> : <span>Rue 2</span>}</label>
                <input type="text" name="street2" value={this.state.street2} onChange={this.street2Change.bind(this)}/>
              </p>

              <p>
                <label for="city">{this.props.lang === "en" ? <span>City</span> : <span>Ville</span>}</label>
                <input type="text" name="city" value={this.state.city} onChange={this.cityChange.bind(this)}/>
              </p>

              <p>
                <label for="province">Province</label>
                <input type="text" name="province" value={this.state.province} onChange={this.provinceChange.bind(this)}/>
              </p>

              <p>
                <label for="postal">{this.props.lang === "en" ? <span>Postal Code</span> : <span>Code postal</span>}</label>
                <input type="text" name="postal" value={this.state.postal} onChange={this.postalChange.bind(this)}/>
              </p>

              <p>
                <label for="notes">{this.props.lang === "en" ? <span>Notes</span> : <span>Remarque</span>}</label>
                <textarea rows="5" name="notes" value={this.state.notes} onChange={this.notesChange.bind(this)}></textarea>
              </p>

              <p>
                <input type="button" name="cmdSubmit" class="submitbtn" value="Submit" onClick={ this.validateForm }/>
              </p>
          </div>
          }
            {this.state.popMessage !== "" && <div className="popup_message">
              {this.state.popMessage}
            </div>
            }

        </form>
        </div>
      </div>
    );
  }
}

export default Popup;